import { Text } from './Text'
import { Props } from './typings'

export function P3(props: Props) {
  const { children = '', as, className = '', style, size, weight, ...p } = props

  return (
    <Text size="$p3" weight="$regular" as={'p'} style={style} className={className} {...p}>
      {children}
    </Text>
  )
}
